import classNames from 'classnames';
import React from 'react';
import ToastProvider from '../../components/toasts/ToastProvider';
import AppRouter from '../../routing/AppRouter';
export default (function () {
    return (React.createElement("div", { id: "app-container", className: classNames('light', 'app-container') },
        React.createElement(ToastProvider, null,
            React.createElement(AppRouter, null))));
});
